let nextId = 1
const state = {
  notifications: [],
  showNotification: false,
  notification: null,
}

const getters = {
  notifications: (state) => state.notifications,
}

const actions = {
  add({ commit }, notification) {
    const id = nextId++
    const newNotification = Object.assign({}, notification, { id })
    commit('APPEND_NOTIFICATION_ARRAY', newNotification)
  },
  error({ dispatch }, error) {
    const message =
      error && error.response && error.response.data
        ? error.response.data.message
          ? Array.isArray(error.response.data.message) &&
            error.response.data.message.length > 0
            ? error.response.data.message[0]
            : error.response.data.message
          : error.response.data
        : error
    dispatch('add', { type: 'error', message })
  },
  info({ dispatch }, message) {
    const info = { type: 'info', message }
    dispatch('add', info)
  },
  remove({ commit }, notification) {
    commit('REMOVE_NOTIFICATION', notification)
  },
  clear({ commit }) {
    commit('CLEAR_NOTIFICATION')
  },
}

const mutations = {
  APPEND_NOTIFICATION_ARRAY(state, notification) {
    state.notifications = [notification, ...state.notifications]
  },
  REMOVE_NOTIFICATION(state, id) {
    state.notifications = state.notifications.filter((n) => n.id !== id)
  },
  CLEAR_NOTIFICATION(state) {
    state.notifications = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
